import { CodeBoxWordmark } from '../components/BrandLogo';
import { API_BASE_URL } from '../lib/api';

/**
 * Code Box has no login form of its own (spec D7): identity-api owns credentials. If a Techedify
 * session already exists on the parent cookie domain, the silent refresh in AuthContext signs the
 * user in with no interaction; this screen only appears when there is no session at all.
 *
 * With no session there is nothing for a silent refresh to exchange, so the button starts the OAuth
 * client flow (D7 path b) at box-api, which owns the PKCE round trip and hands the token back in the
 * fragment. It must NOT link to identity-api directly: that service is a headless JSON API whose
 * /auth/login is POST-only — a GET lands on a 404, which is what this screen used to do.
 */
export function SignInPage() {
  const returnTo = typeof window !== 'undefined' ? window.location.href : '';
  const signInUrl = `${API_BASE_URL}/box/auth/oauth/start?redirect=${encodeURIComponent(returnTo)}`;

  return (
    <div className="flex h-full items-center justify-center p-6">
      <div className="w-full max-w-sm overflow-hidden rounded-card bg-surface shadow-card">
        {/* brand hero: the full wordmark is white lettering, so it lives on the deep brand blue */}
        <div className="grid place-items-center bg-brand px-6 py-10">
          <CodeBoxWordmark className="h-28 w-auto" />
        </div>
        <div className="space-y-5 p-6 text-center">
          <div className="space-y-2">
            <h1 className="text-xl font-bold">Welcome to Code Box</h1>
            <p className="text-sm text-muted">
              Describe an app or game in your own words and build it step by step. Sign in with your
              Techedify account to start.
            </p>
          </div>
          <a
            href={signInUrl}
            className="inline-flex w-full items-center justify-center rounded-field bg-accent px-4 py-2.5 text-sm font-bold text-accent-ink transition hover:brightness-110"
          >
            Sign in
          </a>
        </div>
      </div>
    </div>
  );
}
